/// <amd-module name="Wit/WorkItemForm/History/Diffs/AttachmentDiff" />
import * as React from "react";
import { useCallback } from "react";
import { usePageContext } from "VSS/Platform/Layout";
import { Icon } from "VSSUI/Icon";
import { Link } from "VSSUI/Link";
import { WorkItemRelation } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { useWorkItem } from "../../Common/Hooks";
import { IWorkItemFormAttachmentsService } from "../../Common/Services";
import { getAttachmentIconName, downloadAttachment } from "../../Attachments/AttachmentUtils";

export interface IAttachmentUpdateProps {
    attachment: WorkItemRelation;
    changeType: "added" | "removed" | "updated";
}

export function AttachmentDiff({ attachment, changeType }: IAttachmentUpdateProps) {
    const pageContext = usePageContext();
    const workItem = useWorkItem();
    const onLinkClick = useCallback(() => {
        const attachmentLinkInfo = pageContext
            .getService<IWorkItemFormAttachmentsService>("IWorkItemFormAttachmentsService")
            .getAttachments(workItem)
            .find(a => a.ExtID === attachment.attributes.id);

        if (!attachmentLinkInfo) {
            return;
        }

        downloadAttachment(pageContext, workItem, attachmentLinkInfo);
    }, [attachment]);

    const text = changeType === "removed" ? attachment.attributes.name : <Link onClick={onLinkClick}>{attachment.attributes.name}</Link>;

    const content = (
        <div className="padding-vertical-4 margin-bottom-8 history-test-step-attachment">
            <Icon iconName={getAttachmentIconName(attachment.attributes.name)} className="icon-margin" ariaHidden />
            <span className={`${changeType} padding-vertical-4 padding-horizontal-8`}>{text}</span>
        </div>
    );

    return changeType === "added" ? <ins>{content}</ins> : changeType === "removed" ? <del>{content}</del> : <div>{content}</div>;
}
